import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const hashId = hash.substring(1);
      let cancelled = false;

      const scrollToHash = () => {
        if (cancelled) return;
        const element = document.getElementById(hashId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          return;
        }
        // Use MutationObserver to wait for the element to appear
        const observer = new MutationObserver(() => {
          const el = document.getElementById(hashId);
          if (el) {
            observer.disconnect();
            el.scrollIntoView({ behavior: 'smooth' });
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
        // Fallback timeout to disconnect observer after 10s
        setTimeout(() => {
          if (!cancelled) observer.disconnect();
        }, 10000);
      };

      // Small initial delay for first render
      setTimeout(scrollToHash, 100);

      return () => { cancelled = true; };
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
